(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class YoruxFooterCategories extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.categories = Array.from(
        this.querySelectorAll('[data-yf-category]')
      );

      this.desktopQuery = window.matchMedia(
        '(min-width: 750px)'
      );

      this.handleBreakpoint =
        this.updateCategories.bind(this);

      if (
        typeof this.desktopQuery.addEventListener ===
        'function'
      ) {
        this.desktopQuery.addEventListener(
          'change',
          this.handleBreakpoint
        );
      } else {
        this.desktopQuery.addListener(
          this.handleBreakpoint
        );
      }

      this.updateCategories();
      this.dataset.ready = 'true';
    }

    disconnectedCallback() {
      if (!this.desktopQuery) return;

      if (
        typeof this.desktopQuery.removeEventListener ===
        'function'
      ) {
        this.desktopQuery.removeEventListener(
          'change',
          this.handleBreakpoint
        );
      } else {
        this.desktopQuery.removeListener(
          this.handleBreakpoint
        );
      }
    }

    updateCategories() {
      const isDesktop = this.desktopQuery.matches;

      this.categories.forEach((category) => {
        const shouldOpen = isDesktop
          ? category.dataset.openDesktop === 'true'
          : category.dataset.openMobile === 'true';

        category.open = shouldOpen;
      });
    }
  }

  if (
    !customElements.get(
      'yorux-footer-categories'
    )
  ) {
    customElements.define(
      'yorux-footer-categories',
      YoruxFooterCategories
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class YoruxStickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header--yorux');

      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);

      this.mediaQuery.addEventListener(
        'change',
        this.setHeaderHeightHandler
      );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );

      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

      if (this.mediaQuery && this.setHeaderHeightHandler) {
        this.mediaQuery.removeEventListener(
          'change',
          this.setHeaderHeightHandler
        );
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;

      if (
        this.predictiveSearch &&
        this.predictiveSearch.isOpen
      ) {
        return;
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove(
        'shopify-section-header-hidden'
      );
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeSearchModal() {
      const searchModal = this.querySelector('details-modal');

      if (
        searchModal &&
        typeof searchModal.close === 'function'
      ) {
        searchModal.close(false);
      }
    }
  }

  if (!customElements.get('yorux-sticky-header')) {
    customElements.define(
      'yorux-sticky-header',
      YoruxStickyHeader
    );
  }

  } catch(e) { console.error(e); }
})();
})();
